export const reactSelectChange = (e) => {
  let result = [];
  e.forEach((element) => {
    result.push(element.value);
  });
  return result;
};
